(() => {
  const applyKruzerClaimFixes = () => {
    const root = document.querySelector('[data-kz]');
    if (!root) return;

    root.querySelectorAll('.kz-specbar__inner span').forEach((item) => {
      const text = item.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      if (text.includes('euro v') || (text.includes('norma') && text.includes('stage v'))) {
        item.remove();
      }
    });

    root.querySelectorAll('.kz-hero__proof span, .kz-trust__item').forEach((item) => {
      const text = item.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      if (!text.includes('2 lata gwarancji')) return;

      const small = item.querySelector('small');
      if (small) {
        small.textContent = 'lub 500 mth — zależnie, co nastąpi wcześniej';
      }
    });

    root.querySelectorAll('p').forEach((paragraph) => {
      if (paragraph.textContent.includes('pokażemy właściwy model')) {
        paragraph.innerHTML = paragraph.innerHTML.replace('pokażemy właściwy model', 'pokażemy orientacyjnie dopasowane modele');
      }
    });

    const calculator = document.querySelector('#dobor-agregatu, [data-kz-wizard], .kz-wizard');
    if (calculator && !document.getElementById('kz-calculator-disclaimer')) {
      const note = document.createElement('p');
      note.id = 'kz-calculator-disclaimer';
      note.className = 'kz-calculator-disclaimer';
      note.innerHTML = '<strong>Ważne:</strong> wynik ma charakter orientacyjny. Przed zakupem sprawdź moc znamionową, napięcie i prąd rozruchowy urządzeń. Przy pompach, silnikach, sprężarkach, spawarkach i odbiornikach 400 V potwierdź dobór z doradcą KRUZER.';
      const intro = calculator.querySelector('.kz-section__intro, .kz-wizard__intro, header') || calculator.firstElementChild;
      if (intro) intro.insertAdjacentElement('afterend', note);
      else calculator.prepend(note);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyKruzerClaimFixes, { once: true });
  } else {
    applyKruzerClaimFixes();
  }
})();
